let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iY5MP")).then(() => parcelRequire('3d2EW'));